import React from "react";
import { Controller } from "react-hook-form";
import styles from "./CheckboxGroup.module.scss";
import withLabelAndError from "../withLabelAndError";
import { combineClasses } from "@/lib/utils";
import {
  InputControlProps,
  WithLabelAndErrorComponent,
} from "@/types/formControls";

type Option = {
  label: string;
  value: string;
};

interface CheckboxGroupProps extends InputControlProps {
  options: Option[];
}

const CheckboxGroup: React.FC<CheckboxGroupProps> = (props) => {
  const {
    control,
    register,
    validations,
    name,
    options = [],
    error,
    className,
  } = props;

  const renderGroup = (field: any = {}) => {
    const { value = [], onChange } = field;

    const handleCheckboxChange = (optValue: string, isChecked: boolean) => {
      let newValue = Array.isArray(value) ? [...value] : [];
      if (isChecked) {
        if (!newValue.includes(optValue)) {
          newValue.push(optValue);
        }
      } else {
        newValue = newValue.filter((v) => v !== optValue);
      }
      onChange?.(newValue);
    };

    return (
      <div className={combineClasses(styles.wrapper, className)}>
        {options.map((opt) => {
          const isChecked = Array.isArray(value) && value.includes(opt.value);

          return (
            <label
              key={opt.value}
              className={combineClasses(
                styles.checkboxCard,
                error ? styles.error : ""
              )}
            >
              <span className={styles.label}>{opt.label}</span>
              <div className={styles.checkboxWrapper}>
                <input
                  type="checkbox"
                  className={styles.checkboxInput}
                  checked={isChecked}
                  onChange={(e) =>
                    handleCheckboxChange(opt.value, e.target.checked)
                  }
                />
                <span className={styles.checkmark}></span>
              </div>
            </label>
          );
        })}
      </div>
    );
  };

  if (control) {
    return (
      <Controller
        control={control}
        name={name}
        rules={validations}
        render={({ field }) => renderGroup(field)}
      />
    );
  }

  return renderGroup();
};

const CheckboxGroupWithLabelAndError = withLabelAndError(
  CheckboxGroup as WithLabelAndErrorComponent,
);

export default CheckboxGroupWithLabelAndError;
export { CheckboxGroup };
